"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    formatDateTime: function() {
        return formatDateTime;
    },
    getClientLocale: function() {
        return getClientLocale;
    },
    getClientTimeZone: function() {
        return getClientTimeZone;
    }
});
function getClientLocale() {
    if (typeof navigator !== "undefined") {
        return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || navigator.userLanguage || "en-US";
    }
    return "en-US"; // Fallback in case navigator is not available
}
function getClientTimeZone() {
    if (typeof Intl !== "undefined") {
        try {
            return new Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (err) {
            // Fall back to navigator timezone if Intl is not supported
            return getClientLocale();
        }
    }
    return "UTC"; // Fallback to UTC if Intl is not available
}
function timeFormatter(timezone) {
    const clientLocale = getClientLocale();
    return new Intl.DateTimeFormat(clientLocale, {
        timeStyle: "long",
        dateStyle: "short",
        timeZone: timezone
    });
}
function getDateTimeFromMillisecondsTZ(ms, timezone) {
    const date = new Date(ms || 0);
    timezone = timezone || "utc"; // Use default value if timezone is undefined or null
    return timeFormatter(timezone).format(date);
}
function formatDateTime(imageDateTime = {}) {
    const { day, millisecondsSinceStartOfTheDay, month, timeZone, utcMilliseconds, year4Digits } = imageDateTime;
    if (utcMilliseconds || timeZone) {
        return getDateTimeFromMillisecondsTZ(utcMilliseconds, timeZone);
    } else {
        const currDate = new Date(year4Digits, month - 1, day, 0);
        const currTime = new Date(0);
        currTime.setTime(millisecondsSinceStartOfTheDay);
        return new Date([
            currDate.toDateString(),
            currTime.toTimeString()
        ]).toLocaleString(getClientLocale(), {
            timeZone,
            timeZoneName: "short"
        });
    }
}
